<template>
    <a-modal
        :visible="visible"
        :title="$t('taskModuleRules.dynamicVariables')"
        width="600px"
        :footer="null"
        @cancel="onClose"
    >
        <div class="variables-picker">
            <p class="info-text">
                {{ $t("taskModuleRules.clickOnVariableToUse") }}
            </p>

            <a-collapse :bordered="false" default-active-key="task">
                <!-- Task Fields -->
                <a-collapse-panel key="task" header="Görev Bilgileri">
                    <div class="variables-grid">
                        <div
                            v-for="variable in taskVariables"
                            :key="variable.value"
                            class="variable-item"
                            @click="selectVariable(variable.value)"
                        >
                            <code v-pre>{{'{{' + variable.value + '}}'}}</code>
                            <span class="variable-label">{{ variable.label }}</span>
                        </div>
                    </div>
                </a-collapse-panel>

                <!-- Task Relations -->
                <a-collapse-panel key="relations" header="Görev İlişkileri">
                    <div class="variables-grid">
                        <div
                            v-for="variable in relationVariables"
                            :key="variable.value"
                            class="variable-item"
                            @click="selectVariable(variable.value)"
                        >
                            <code v-pre>{{'{{' + variable.value + '}}'}}</code>
                            <span class="variable-label">{{ variable.label }}</span>
                        </div>
                    </div>
                </a-collapse-panel>

                <!-- System Fields -->
                <a-collapse-panel key="system" header="Sistem Bilgileri">
                    <div class="variables-grid">
                        <div
                            v-for="variable in systemVariables"
                            :key="variable.value"
                            class="variable-item"
                            @click="selectVariable(variable.value)"
                        >
                            <code v-pre>{{'{{' + variable.value + '}}'}}</code>
                            <span class="variable-label">{{ variable.label }}</span>
                        </div>
                    </div>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: "DynamicVariablesPicker",
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            taskVariables: [
                { label: 'Görev ID', value: 'task._id' },
                { label: 'Görev Başlığı', value: 'task.title' },
                { label: 'Görev Açıklaması', value: 'task.description' },
                { label: 'Görev Önceliği', value: 'task.priority' },
                { label: 'Görev Stage Adı', value: 'task.stage.name' },
                { label: 'Görev Workflow Adı', value: 'task.workflow.title' },
                { label: 'Görev Sahibi Adı', value: 'task.owner.name' },
                { label: 'Görev Sahibi E-posta', value: 'task.owner.email' },
                { label: 'Görev Atananlar Adları', value: 'task.assignees[].name' },
                { label: 'Görev Atananlar E-postaları', value: 'task.assignees[].email' },
                { label: 'Görev Takipçiler Adları', value: 'task.followers[].name' },
                { label: 'Görev İşbirlikçiler Adları', value: 'task.collaborators[].name' },
                { label: 'Görev Etiket Adları', value: 'task.tags[].name' },
                { label: 'Görev Başlangıç Tarihi', value: 'task.startDate' },
                { label: 'Görev Bitiş Tarihi', value: 'task.endDate' },
                { label: 'Görev Oluşturma Tarihi', value: 'task.createdAt' },
                { label: 'Görevi Oluşturan Kullanıcı', value: 'task.createdBy.user.name' }
            ],
            relationVariables: [
                { label: 'İlişkili Kişi Adı', value: 'task.relation.visitor.fullname' },
                { label: 'İlişkili Kişi E-posta', value: 'task.relation.visitor.email' },
                { label: 'İlişkili Kişi Telefon', value: 'task.relation.visitor.phone' },
                { label: 'İlişkili Kişi WhatsApp', value: 'task.relation.visitor.whatsappNumber' },
                { label: 'İlişkili Kişi Platformu', value: 'task.relation.visitor.platform' },
                { label: 'İlişkili Konuşma Departmanı', value: 'task.relation.conversation.subject.name' },
                { label: 'İlişkili Konuşma Durumu', value: 'task.relation.conversation.status' }
            ],
            systemVariables: [
                { label: 'Bugünün Tarihi', value: 'system.date' },
                { label: 'Şu Anki Saat', value: 'system.time' },
                { label: 'Tarih ve Saat', value: 'system.datetime' }
            ]
        };
    },
    methods: {
        onClose() {
            this.$emit("close");
        },

        selectVariable(variable) {
            this.$emit("select", variable);
            this.onClose();
        }
    }
};
</script>

<style lang="scss" scoped>
.variables-picker {
    .info-text {
        color: #666;
        font-size: 14px;
        margin-bottom: 16px;
        padding: 12px;
        background: #f0f7ff;
        border-radius: 6px;
        border-left: 3px solid #1890ff;
    }

    .variables-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 8px;

        .variable-item {
            padding: 12px;
            background: #fafafa;
            border: 1px solid #e8e8e8;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: #e6f7ff;
                border-color: #1890ff;
            }

            code {
                display: block;
                font-size: 13px;
                color: #1890ff;
                margin-bottom: 4px;
                font-family: 'Courier New', monospace;
            }

            .variable-label {
                font-size: 12px;
                color: #666;
            }
        }
    }
}

:deep(.ant-collapse) {
    background: transparent;
    border: none;

    .ant-collapse-item {
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
            border-bottom: none;
        }
    }

    .ant-collapse-header {
        font-weight: 600;
        color: #1a1a1a;
    }

    .ant-collapse-content {
        background: transparent;
        border-top: 1px solid #f0f0f0;
    }
}
</style>
